export const bacteriaLayoutConfig_9P_eng = [
    {
        label: 'Bacteroides genus',
        page: 12,
        yOffset: 208,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 200,
        yResult: 200,
        yResulttext: 204,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 298,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 290,
        yResult: 290,
        yResulttext: 294,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium breve',
        page: 12,
        yOffset: 335,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 327,
        yResult: 327,
        yResulttext: 331,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 12,
        yOffset: 372,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 364,
        yResult: 364,
        yResulttext: 368,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 12,
        yOffset: 409,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 401,
        yResult: 401,
        yResulttext: 405,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 12,
        yOffset: 446,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 438,
        yResult: 438,
        yResulttext: 442,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 12,
        yOffset: 483,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 475,
        yResult: 475,
        yResulttext: 479,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 12,
        yOffset: 520,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 512,
        yResult: 512,
        yResulttext: 516,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 12,
        yOffset: 557,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 549,
        yResult: 549,
        yResulttext: 553,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 594,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 586,
        yResult: 586,
        yResulttext: 590,
        xResulttext: 585,
        show_result: true
    },
    {
      label: 'Bifidobacterium bifidum',
      page: 16,
      yOffset: 128,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 118,
      yResult: 512,
      yResulttext: 122,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bifidobacterium breve',
      page: 16,
      yOffset: 460,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 450,
      yResult: 512,
      yResulttext: 454,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bifidobacterium lactis',
      page: 16,
      yOffset: 635,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 625,
      yResult: 512,
      yResulttext: 629,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bifidobacterium longum',
      page: 16,
      yOffset: 830,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 820,
      yResult: 512,
      yResulttext: 824,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus acidophilus',
      page: 17,
      yOffset: 104,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 94,
      yResult: 512,
      yResulttext: 98,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus gasseri',
      page: 17,
      yOffset: 260,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 250,
      yResult: 512,
      yResulttext: 254,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus paracasei',
      page: 17,
      yOffset: 523,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 513,
      yResult: 512,
      yResulttext: 517,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus reuteri',
      page: 17,
      yOffset: 790,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 780,
      yResult: 512,
      yResulttext: 784,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus rhamnosus',
      page: 18,
      yOffset: 110,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 100,
      yResult: 512,
      yResulttext: 104,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bacteroides genus',
      page: 18,
      yOffset: 456,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 450,
      yResult: 450,
      yResulttext: 452,
      xResulttext: 585,         
      show_result: false
    }
];

export const bacteriaLayoutConfig_9P_thai = [
    {
        label: 'Bacteroides genus',
        page: 11,
        yOffset: 208,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 200,
        yResult: 200,
        yResulttext: 204,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 298,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 290,
        yResult: 290,
        yResulttext: 294,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium breve',
        page: 11,
        yOffset: 335,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 327,
        yResult: 327,
        yResulttext: 331,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 11,
        yOffset: 372,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 364,
        yResult: 364,
        yResulttext: 368,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 11,
        yOffset: 409,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 401,
        yResult: 401,
        yResulttext: 405,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 11,
        yOffset: 446,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 438,
        yResult: 438,
        yResulttext: 442,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 11,
        yOffset: 483,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 475,
        yResult: 475,
        yResulttext: 479,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 11,
        yOffset: 520,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 512,
        yResult: 512,
        yResulttext: 516,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 11,
        yOffset: 557,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 549,
        yResult: 549,
        yResulttext: 553,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 11,
        yOffset: 594,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 586,
        yResult: 586,
        yResulttext: 590,
        xResulttext: 585,
        show_result: true
    },
    {
      label: 'Bifidobacterium bifidum',
      page: 15,
      yOffset: 135,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 125,
      yResult: 512,
      yResulttext: 129,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bifidobacterium breve',
      page: 15,
      yOffset: 495,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 485,
      yResult: 512,
      yResulttext: 489,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bifidobacterium lactis',
      page: 15,
      yOffset: 670,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 660,
      yResult: 512,
      yResulttext: 664,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Bifidobacterium longum',
      page: 15,
      yOffset: 845,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 835,
      yResult: 512,
      yResulttext: 839,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus acidophilus',
      page: 16,
      yOffset: 108,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 98,
      yResult: 512,
      yResulttext: 102,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus gasseri',
      page: 16,
      yOffset: 260,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 250,
      yResult: 512,
      yResulttext: 254,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus paracasei',
      page: 16,
      yOffset: 490,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 480,
      yResult: 512,
      yResulttext: 484,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus reuteri',
      page: 16,
      yOffset: 762,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 752,
      yResult: 490,
      yResulttext: 756,
      xResulttext: 585,         
      show_result: false
    },
    {
      label: 'Lactobacillus rhamnosus',
      page: 17,
      yOffset: 110,
      xLabel: 70,
      xBarStart: 300,
      xBarGap: 53,
      xResult: 685,
      yLabel: 100,
      yResult: 512,
      yResulttext: 104,
      xResulttext: 585,         
      show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 17,
        yOffset: 451,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 445,
        yResult: 443,
        yResulttext: 445,
        xResulttext: 585,         
        show_result: false
    }
];